import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface LeadStatusErrorAlertProps {
  leadStatusError: boolean;
}

export function LeadStatusErrorAlert({
  leadStatusError
}: LeadStatusErrorAlertProps) {
  if (!leadStatusError) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="lead-status-error-message"
        displayCloseButton={false}
        role="info"
        type="info"
      >
        <span>{ErrorMessages.LEAD_STATUS_UNAVAILABLE}</span>
      </Alert>
    </StyledContainerAlert>
  );
}
